
import { Vue, Options } from "vue-class-component";
import { ref } from 'vue';

@Options({
    components: {
        
    },
    props: {
      theme: String
    },
    watch: {
      theme(val) {
        this._theme = val;
      }
    }
  }
)

export default class Navbar extends Vue {
  
   _theme: any = ref('dark');
  toggleTheme () : void {
    var theme = this._theme === 'light' ? 'dark' : 'light';
    this.$emit('toggleTheme', theme);
  }

  get propValue()
  {
    return this._theme;
  }

  
}
